import { mapActions } from "vuex";

export const importMixin = {
  data() {
    return {
      loading: false,
      layers: [
        {
          layer: "fc_cable",
          hasExtraFormDataField: false,
          objectProperties: ["cb_geometry", "cb_id"]
        },
        {
          layer: "fc_slack",
          hasExtraFormDataField: false,
          objectProperties: ["sl_id"]
        },
        {
          layer: "fc_building",
          hasExtraFormDataField: false,
          objectProperties: ["bd_id", "bd_uuid", "bd_technical_site_id"]
        },
        {
          layer: "fc_pathway",
          hasExtraFormDataField: false,
          objectProperties: ["geom", "pw_length", "pw_precision_class"]
        },
        {
          layer: "fc_pole",
          hasExtraFormDataField: true,
          objectProperties: ["tp_id", "tp_label", "tp_status"]
        },
        {
          layer: "fc_manhole",
          hasExtraFormDataField: true,
          objectProperties: ["tp_id", "tp_label", "tp_status"]
        },
        {
          layer: "fc_cabinet",
          hasExtraFormDataField: true,
          objectProperties: ["tp_id", "tp_label", "tp_status"]
        },
        {
          layer: "fc_closure",
          hasExtraFormDataField: false,
          objectProperties: ["cl_id", "cl_label", "cl_uuid"]
        },
        {
          layer: "fc_closure_zone",
          hasExtraFormDataField: false,
          objectProperties: ["clz_id", "clz_label", "clz_uuid"]
        },
        {
          layer: "fc_fiber_distribution_point",
          hasExtraFormDataField: true,
          objectProperties: ["ts_id", "ts_label", "ts_uuid"]
        },
        {
          layer: "fc_fdp_zone",
          hasExtraFormDataField: false,
          objectProperties: ["fdpz_id", "fdpz_label", "fdpz_uuid"]
        },
        {
          layer: "fc_optical_line_termination",
          hasExtraFormDataField: true,
          objectProperties: ["ts_id", "ts_label", "ts_uuid"]
        },
        {
          layer: "fc_olt_zone",
          hasExtraFormDataField: false,
          objectProperties: ["oltz_id", "oltz_label", "oltz_uuid"]
        },
        {
          layer: "fc_annotation_point",
          hasExtraFormDataField: false,
          objectProperties: ["anp_id", "anp_label", "anp_uuid"]
        },
        {
          layer: "fc_annotation_zone",
          hasExtraFormDataField: false,
          objectProperties: ["anz_id", "anz_label", "anz_uuid"]
        },
        {
          layer: "fc_cartography",
          hasExtraFormDataField: false,
          objectProperties: ["ctg_id", "ctg_label", "ctg_uuid"]
        }
      ]
    };
  },

  methods: {
    ...mapActions(["FETCH_ALL_OBJECTS_PROPERTIES_WITHOUT_FIELDS"]),

    /**
     * Get's the name to exhibit on the layer option label.
     * @param {String} layer - layer being analysed
     * @returns {String}
     */
    getLayerName(layer) {
      let label = this.$store.getters.getLayerTranslationKey(layer);
      return this.$i18n.tc(label, 2);
    },

    async getLayersInfo() {
      try {
        let objectProperties = this.$store.getters.getAllObjectTypesProperties;

        if (objectProperties.length > 0) {
          this.updateLayersInfo();
        } else {
          await this.FETCH_ALL_OBJECTS_PROPERTIES_WITHOUT_FIELDS();
          this.updateLayersInfo();
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },

    updateLayersInfo() {
      this.layers.forEach(layer => {
        layer.endpoint = this.$store.getters.getLayerEndpoint(layer.layer);
        layer.permissionName = this.$store.getters.getLayerPermissionName(
          layer.layer
        );
        layer.label = this.getLayerName(layer.layer);
      });
    }
  }
};



// WEBPACK FOOTER //
// ./src/mixins/management/importMixin.js